/* eslint-disable  */
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import CediSymbol from "../../Components/CediSymbol";
import Loader from "../../Components/Loader";
import { dataActionCreators } from "../../services/Actions";
import "../css/fundDed.css";
import "../css/pages.css";
import RenderAdminPage from "../RenderAdminPage";
import { GetTotal } from "../../services/Actions/dataAction";
import { GhanaMoneyDisplay } from "../../helpers/helper";
import CohortFilter, { COHORT, cohortQuery } from "../../Components/CohortFilter";
function FundDeductions() {
  const dispatch = useDispatch();
  const { GetAllFunds } = bindActionCreators(dataActionCreators, dispatch);
  const [limit, setLimit] = useState(20);

  const [search, setSearch] = useState(null);
  // Members or UPNMG staff. Every GetAllFunds call below goes through
  // cohortQuery() so switching cohort cannot leave one call site behind and
  // desync the list from the filter.
  const [cohort, setCohort] = useState(COHORT.MEMBERS);


  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = limit;
  const [currentPage, setCurrentPage] = useState(0);
  const data = useSelector((state) => state.data);
  // const paginate = data?.paginate
  const { funds, paginate, isLoading, totalFunds, total_fund } = data;

  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;

    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(funds?.slice(itemOffset, endOffset));
    setPageCount(Number(paginate?.total));
  }, [itemOffset, itemsPerPage, funds]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    console.log("event", event);

    console.log('search', search)
    GetAllFunds(true, event.selected + 1, limit, cohortQuery(search, cohort));

    console.log("currentPage", currentPage);

    const newOffset = (event.selected * itemsPerPage) % paginate?.total;

    setItemOffset(newOffset);
  };

  console.log("data", data);

  const handleLimit = (e) => {
    setLimit(e.target.value);
  };

  const onSearchTextChange = debounce((e) => {
    if (e?.target?.value) {
      setSearch(e?.target?.value ?? null);
      console.log("search", search);
      console.log("e?.target?.value", e?.target?.value);
      GetAllFunds(true, 1, 15, cohortQuery(e?.target?.value, cohort));
    } else {
      setSearch(null);
      GetAllFunds(true, 1, 15, cohortQuery(null, cohort));
    }
  }, 800);

  // const handleSearch = debounce((e) => {
  //     setSearch(prevState => {
  //       return {
  //         ...prevState,
  //         [e.target.name] : e.target.value
  //       }
  //     })
  //     if(search){
  //       console.log('search', search)
  //        GetAllFunds(true, 1, 15, `&search=${search}`)
  //     }else{
  //       GetAllFunds(true, 1, 15, null)
  //     }
  // }, 800)

  // const handleSearch = (e) => {
  //   setSearch(e.target.value)
  // }

  useEffect(() => {
    GetAllFunds(true, 1, limit, cohortQuery(search, cohort));
  }, []);

  // Also the cohort switch's refetch — the toggle has no handler of its own.
  // GetTotal goes with it: the Total tile falls back to the dashboard-wide
  // figure whenever the listing omits one (it only returns a total on the
  // search branch), so leaving it behind would print a member total over a
  // staff table.
  useEffect(() => {
    GetAllFunds(true, 1, limit, cohortQuery(search, cohort));
    dispatch(GetTotal(cohort));
  }, [limit, cohort]);

  return (
    <div>
      <RenderAdminPage title="Fund Deductions">
        {isLoading && <Loader />}

        <div className="flex flex-col sm:flex-row gap-3 mb-6">
          <div className="flex-1">
            <label htmlFor="search" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Search</label>
            <input
              type="search"
              onChange={onSearchTextChange}
              id="search"
              placeholder="Search by staff ID, name..."
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all placeholder:text-slate-400"
            />
          </div>
          <CohortFilter value={cohort} onChange={setCohort} label="Contributions for" />
          <div className="w-full sm:w-40">
            <label htmlFor="limit" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Show</label>
            <select className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all" onChange={handleLimit}>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={70}>70</option>
              <option value={100}>100</option>
              <option value={150}>150</option>
              <option value={250}>250</option>
              <option value={350}>350</option>
              <option value={500}>500</option>
              <option value={600}>600</option>
            </select>
          </div>
        </div>

        <div className="flex justify-between items-center mb-4">
          <p className="text-sm text-slate-500 dark:text-slate-400">{funds?.length || 0} records</p>
          <div className="text-sm font-semibold text-slate-700 dark:text-slate-300">Total: <span className="text-indigo-600 dark:text-indigo-400"><GhanaMoneyDisplay amount={total_fund ?? totalFunds} /></span></div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 dark:bg-gray-700/50">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Member Info</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Amount</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Period</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Transaction</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Facility</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-gray-700">
                {funds?.length > 0 ? (
                  <>
                    {funds?.map((fund, index) => {
                      return (
                        <tr key={index + 1} className="hover:bg-slate-50 dark:hover:bg-gray-700/30 transition-colors">
                          <td className="px-4 py-3">
                            <div className="flex items-center gap-3">
                              <img className="w-9 h-9 rounded-full object-cover" src={fund?.user?.profile_image || (fund?.user?.name?.split(' ')[0] === "Mr." ? "/images/dev/avarta2.jpeg" : "/images/dev/woman-avarta.jpeg")} alt="" />
                              <div>
                                <p className="text-sm font-medium text-slate-800 dark:text-slate-200">{fund?.user?.name}</p>
                                <p className="text-xs text-slate-500 dark:text-slate-400 font-semibold">{fund?.staff_id}</p>
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300"><CediSymbol />{fund?.deduction}</td>
                          <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{fund?.period}</td>
                          <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{fund?.transaction_type}</td>
                          <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{fund?.user?.facility}</td>
                          <td className="px-4 py-3 text-right">
                            <button type="button" className="text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">
                              <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24"><path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" /></svg>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr><td colSpan="6" className="px-4 py-12 text-center text-sm text-slate-400 dark:text-slate-500">No data available</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {funds.length > 0 && (
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        )}

      </RenderAdminPage>
    </div>
  );
}

export default FundDeductions;
